import { createSelector } from "reselect";

import { getSelectedStops } from "./stopFilters";
import * as stopModel from "../../../../models/stop";
import { getUniqueRoutesFromNextWaves } from "../../../../models/routeDetail";

export const getSelectedParcels = (state) =>
  state.ui.routeDetail.selectedParcels;

export const getUniqueRoutesFromSelectedParcels = createSelector(
  getSelectedParcels,
  getUniqueRoutesFromNextWaves
);

export const getSelectedParcelsCount = createSelector(
  getSelectedParcels,
  stopModel.getSelectedParcelsCount
);

export const getRemainingParcelCodes = createSelector(
  getSelectedStops,
  getSelectedParcels,
  stopModel.getRemainingParcelCodes
);
